import type {
    SelectCommerceCheckoutPaymentOptionRequest,
    SelectCommerceCheckoutPaymentOptionResponse,
} from "@teqtank/commerce-contracts";
import type { CommerceOperation } from "@teqtank/commerce-transport";

export const selectCommerceCheckoutPaymentOptionOperation: CommerceOperation<
    SelectCommerceCheckoutPaymentOptionRequest,
    SelectCommerceCheckoutPaymentOptionResponse
> = Object.freeze({
    name: "commerce.checkout.payment-option.select",
});
